import React from 'react';
import { StyledButton } from './styled';
import { Content } from './components/content';
import { ButtonColorProps } from '~/lib';
import { ResetButtonProps } from './ResetButton';

export interface ButtonProps extends ResetButtonProps {
    /**
     * Which theme variant to display button as
     */
    variant?: ButtonColorProps;
    color?: string;
    backgroundColor?: string;
    textColor?: string;
    small?: boolean;
    fullWidth?: boolean;
    isInverted?: boolean;

    size?: 'small' | 'large';
    /**
     * Description of what the button does, this is for screen readers
     * and should be used when content does not describe the action
     */
    description?: string;

    alternativeTextColor?: string;
    alternativeBackgroundColor?: string;
}

export const Button = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, ButtonProps>(
    ({ variant = 'primary', description, children, color, title, ...restProps }, ref) => {
        return (
            <StyledButton
                ref={ref}
                aria-label={title}
                color={color}
                variant={variant || 'primary'}
                {...restProps}
            >
                {description ? <Content description={description}>{children}</Content> : children}
            </StyledButton>
        );
    },
);

Button.displayName = 'Button';
